<template>
  <div class="row health_check">
    <div class="col-12" v-if="hasServiceReports">
      <b-card header="Service Compliance Reports" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row">
          <div class="col-12" >
            <h5>Historic service check reports</h5>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                <tr>
                  <th>Report Date</th>
                  <th>Report Uploaded by</th>
                  <th>View</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="report in service_company_reports">
                  <td>
                    <div class="td_data_outer">
                      <div class="td_data">{{ report.date_of_report | formatDate }}</div>
                    </div>
                  </td>
                  <td>
                    <div class="td_data_outer">
                      <div class="td_data">{{ reportUploadedBy(report) }}</div>
                    </div>
                  </td>
                  <td>
                    <div class="td_data_outer">
                      <div class="td_data">
                        <button v-if="report.file_path !== null"
                                class="btn orcaBtn greenBtn sm_btn" @click.prevent="view_report_modal(report)">View Report
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-12">
      <b-card header="Compliance Health Check" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row">
          <div class="col-12" v-if="!notEmptyObject(health_check) || Object.keys(health_check).length === 1">
            <h5 class="bp_color">Pre Sign Up Health Check</h5>
            <div class="row">
              <div class="col-lg-8">
                <p>Please click the following button to start filling in the health check that should be completed as part of the sales process to evaluate the current state of the
                   company regarding their engagement of contractors.</p>
              </div>
              <div class="col-lg-4">
                <button class="btn orcaBtn sm_btn w-100" @click.prevent="create_health_check">Start Health Check</button>
              </div>
            </div>
          </div>
          <div class="col-12" v-else-if="notEmptyObject(health_check) && health_check.completed_date === null">
            <h5 class="bp_color">Pre Sign Up Health Check</h5>
            <div class="row">
              <div class="col-12">
                <p class="mb-3">Please complete the below health check questionnaire to fully evaluate the company in regards to how they engage with self-employed contractors.</p>
              </div>
              <div class="col-12">
                <health_check :health_check="health_check" :check_completed="check_completed"></health_check>
              </div>
            </div>
          </div>
          <div class="col-12" v-else-if="notEmptyObject(health_check) && health_check.completed_date !== null">
            <h5 class="bp_color">Pre Sign Up Health Check</h5>
            <div class="row">
              <div class="col-12">
                <p class="mb-3">Below is the completed health check questionnaire which fully evaluates the company in regards to how they engage with self-employed contractors
                                .</p>
              </div>
              <div class="col-12">
                <div class="row mb-4">
                  <div class="col-xl-6">
                    <strong>Health Check Completed on :</strong> {{ health_check.completed_date | formatDateTime }}
                  </div>
                  <div class="col-xl-6">
                    <button class="btn orcaBtn sm_btn w-100" @click.prevent="generatePDF">Download PDF Version</button>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <completed_health_check :health_check="health_check" :check_completed="check_completed"></completed_health_check>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import health_check from "pages/companies/record/compliance/health_check";
import completed_health_check from "pages/companies/record/compliance/completed_health_check";
import file_input from 'partials/files/fileInputNOLIMIT';
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';

export default {
  name: "compliance",
  props: ['company', 'health_check', 'service_company_reports'],
  components: {
    Datepicker,
    health_check,
    completed_health_check,
    file_input
  },
  data() {
    return {
      first_service_check_date: null,
      service_check: {
        company_id: this.company.id,
        date_of_report: null,
        next_report_due_date: null,
        file: null,
        report_uploaded_by_id: this.$store.state.auth.me.id
      },
      service_check_carried_out_date_disabled: {
        from: this.$moment.utc().toDate(),
        to: ''
      },
      service_check_next_due_date_disabled: {
        from: '',
        to: this.$moment.utc().toDate()
      },
      saving: false
    }
  },
  computed: {
    hasServiceReports() {
      return this.service_company_reports.length > 0
    },
    ServiceReportInitial() {
      return this.service_company_reports.length === 1 && this.service_company_reports[0].date_of_report === null
    },
    check_completed() {
      let temp = Object.assign({}, this.health_check)
      // remove key values that are always not required to be tested
      delete temp['id'];
      delete temp['company_id'];
      delete temp['created_at'];
      delete temp['updated_at'];
      delete temp['deleted_at'];
      delete temp['completed_date'];
      // remove key values that depend on other answers as to whether they need to be checked
      // Contractors right to send substitute
      if (temp['contractor_right_to_substitution'] === 'No') {
        delete temp['pay_substitute_responsibility'];
        delete temp['text_pay_substitute_responsibility'];
        delete temp['company_right_to_reject_substitute'];
        delete temp['text_company_right_to_reject_substitute'];
      }
      // Company pay training
      if (temp['company_arrange_training'] === 'No') {
        delete temp['company_pay_for_training'];
        delete temp['text_company_pay_for_training'];
      }
      // Vans
      if (temp['company_provide_vans'] === 'No') {
        delete temp['contractor_pay_for_company_vans'];
        delete temp['text_contractor_pay_for_company_vans'];
        delete temp['company_vans_how_used'];
        delete temp['text_company_vans_how_used'];
      }
      // filter temp object into 'text' and radio objects
      let begins_with_text = {};
      let not_text = {};
      for (const [key, value] of Object.entries(temp)) {
        if (key.startsWith('text_')) {
          begins_with_text[key] = value
        }
        else {
          not_text[key] = value
        }
      }
      return Object.keys(not_text).filter(key => not_text[key] === null).length <= 0 &&
          Object.keys(begins_with_text).filter(key => begins_with_text[key] === '' || begins_with_text[key] === null).length <= 0;
    }
  },
  methods: {
    generatePDF() {
      const content = document.getElementById('completed-health-check-content');
      const options = {
        margin: 10,
        filename: 'completed_health_check.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };
      html2pdf().from(content).set(options).save();

    },
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    getNextServiceCheckDate() {
      return this.$options.filters.formatDate(this.service_company_reports.slice(-1)[0].next_report_due_date)
    },
    /*
     * First service check form
     */
    select_first_service_check_date(date) {
      if (date !== null) {
        this.first_service_check_date = this.$moment.utc(date).format('YYYY-MM-DD')
      }
    },
    submit_first_service_check_date() {
      this.saving = true;
      this.$refs.firstServiceCheck.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.firstServiceCheck);
          this.saving = false
        }
        else {
          axios.post(this.crmApiPath + 'company/service_compliance_report', {
            company_id: this.company.id,
            next_report_due_date: this.first_service_check_date,
            report_uploaded_by_id: this.$store.state.auth.me.id,
            file_name: null,
            file_path: null,
            file_upload: 'false'

          }).then(() => {
            this.$bus.$emit('service_check_reports::reload', {action: true});
            this.saving = false
          })
        }
      });
    },

    /*
     * other service checks (not first)
     */
    select_date_of_report(date) {
      if (date !== null) {
        this.service_check.date_of_report = this.$moment.utc(date).format('YYYY-MM-DD')
      }
    },
    select_date_next_report_due(date) {
      if (date !== null) {
        this.service_check.next_report_due_date = this.$moment.utc(date).format('YYYY-MM-DD')
      }
    },
    file_select(file) {
      this.service_check.file = file
    },
    submit_service_check() {
      this.saving = true;
      this.$refs.serviceCheck.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.serviceCheck);
          this.saving = false
        }
        else {
          let file = new FormData()

          let indexLastFullStop = this.service_check.file.name.lastIndexOf('.'),
              fileName = this.service_check.file.name.slice(0, indexLastFullStop),
              fileExtension = this.service_check.file.name.slice(indexLastFullStop + 1),
              file_name = fileName.replace(/ /g, "-") +
                  '-' + this.$moment.utc().format('DDMMYYHHmmss') +
                  '.' + fileExtension

          file.append('company_id', this.service_check.company_id)
          file.append('date_of_report', this.service_check.date_of_report)
          file.append('next_report_due_date', this.service_check.next_report_due_date)
          file.append('file_name', file_name)
          file.append('file_path', 'storage/company_files/' + this.service_check.company_id + '/' + file_name)
          file.append('report_uploaded_by_id', this.$store.state.auth.me.id)
          file.append('file', this.service_check.file)
          file.append('file_upload', 'true')
          // save file and db record
          axios.post(this.crmApiPath + 'company/service_compliance_report', file, {
                 headers: {'Content-Type': 'application/json'}
               })
               .then(() => {
                 // trigger reload service reports data
                 this.$bus.$emit('service_check_reports::reload', {action: true});
                 //reset form data
                 this.service_check = {
                   company_id: this.company.id,
                   date_of_report: null,
                   next_report_due_date: null,
                   file: null,
                   report_uploaded_by_id: this.$store.state.auth.me.id
                 }
                 // reset validations of form
                 this.$nextTick(() => this.$refs.serviceCheck.reset())
                 this.saving = false
               })
        }
      })
    },
    /*
     * uploaded reports (not first)
     */
    reportUploadedBy(report) {
      return report.report_uploaded_by.first_name + ' ' + report.report_uploaded_by.surname
    },
    view_report_modal(report) {
      this.$store.commit('SHOW_VIEW_SERVICE_REPORT_MODAL', {
        file_path: report.file_path,
        uploaded_by: report.report_uploaded_by,
        uploaded_date: report.created_at,
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_service_report_modal'));
    },

    /*
     * other service checks (not first)
     */
    create_health_check() {
      axios.post(this.crmApiPath + 'company/health_check', {
        company_id: this.company.id,
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      }).then(() => {
        this.$bus.$emit('company_health_check::reload', {action: true});
        this.$bus.$emit('logs::reload', {action: true});
      })
    }
  }
}
</script>

<style lang="scss">
.health_check {
  .table {
    td {
      position:    relative;
      height:      45px;
      line-height: 15px;
      padding:     0 0.75rem;

      .td_data_outer {
        height:   45px;
        display:  block;
        width:    100%;
        position: relative;
      }

      .td_data {
        position:  absolute;
        top:       50%;
        transform: translateY(-50%);
        width:     100%;
      }
    }
  }
}
</style>
